export default __webpack_public_path__ + "static/media/undraw_chore_list_re_2lq8.6c9cef20.svg";